import 'reflect-metadata';
import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {map} from 'rxjs/operators';

import {Session} from "src/app/model/session.model";
import {CookieService} from "ngx-cookie-service";
import {ObjectMapper} from "json-object-mapper";
import {environment} from "../../environments/environment";

@Injectable({
  providedIn: "root"
})
export class SessionManagerService {

  isLoggedIn = false;

  session?: Session = undefined;

  constructor(
    private cookies: CookieService,
    private http: HttpClient
  ) {
    this.session = new Session();
  }

  login(username: string, password: string) {
    return this.http.post<Session>("/direct/login", {username, password})
      .pipe(map(response => {
        let session = ObjectMapper.deserialize(Session, response);
        localStorage.setItem("token", this.cookies.get("XSRF-TOKEN"));
        localStorage.setItem("session", JSON.stringify(session));
        this.isLoggedIn = true;
        this.session = session;
        return session;
      }));
  }

  logout() {
    return this.http.post<string>("/direct/logout", {})
      .pipe(map(result => {
        this.isLoggedIn = false;
        this.cookies.delete("XSRF-TOKEN");
        localStorage.removeItem("session");
        localStorage.removeItem("token");
        this.session = undefined;
        return result;
      }));
  }

  token() {
    return this.http.get<Session>(environment.apiPrefix + "/token", {"observe": "response"})
      .pipe(map(response => {
        return response;
      }));
  }
}
